import { createAction, props } from '@ngrx/store';
import { ClassroomAnalytics, Facets, StudentAnalytics, ViewLevel } from '@wam/shared';
import { Params } from '@angular/router';
import { AssignmentResponse } from '@wap/catalog-v5';

export const load = createAction('[Assessments] Load');

export const continueLoad = createAction('[Assessments] Continue Load');

export const loadSuccess = createAction(
  '[Assessments] Load success',
  props<{ hits: ClassroomAnalytics[] | StudentAnalytics[]; totalHits: number }>(),
);

export const continueLoadSuccess = createAction(
  '[Assessments] Continue Load success',
  props<{ hits: ClassroomAnalytics[] | StudentAnalytics[]; totalHits: number }>(),
);

export const updateFacets = createAction(
  '[Assessments API] Update facets',
  props<{ facets: Facets }>(),
);

export const updateSelectedFacets = createAction(
  '[Assessments] Update selected facets',
  props<{ selectedFacets: Facets }>(),
);

export const updateLevel = createAction(
  '[Assessments] Update Level',
  props<{ level: ViewLevel }>(),
);

export const updateStoreFromRoute = createAction(
  '[Assessments] Update Store From Route',
  props<{ view: ViewLevel; queryParams: Params }>(),
);

export const loadStudentAssignments = createAction(
  '[Assessments] Load Student Assignments',
  props<{ userId: string }>(),
);

export const loadStudentAssignmentsSuccess = createAction(
  '[Assessments] Load Student Assignments Success',
  props<{ userId: string; assignments: AssignmentResponse[] }>(),
);

export const loadStudentAssignmentsFailure = createAction(
  '[Assessments] Load Student Assignments Failure',
  props<{ userId: string }>(),
);

export const loadClassAssignments = createAction(
  '[Assessment] Load Class Assignments',
  props<{ classId: string }>(),
);

export const loadClassAssignmentsSuccess = createAction(
  '[Assessment] Load Class Assignments Success',
  props<{ classId: string; assignments: AssignmentResponse[] }>(),
);

export const loadClassAssignmentsFailure = createAction(
  '[Assessment] Load Class Assignments Failure',
  props<{ classId: string }>(),
);

export const loadSchoolAssignments = createAction(
  '[Assessment] Load School Assignments',
  props<{ schoolId: string; grade: string }>(),
);

export const loadSchoolAssignmentsSuccess = createAction(
  '[Assessment] Load School Assignments Success',
  props<{ schoolId: string; grade: string; assignments: AssignmentResponse[] }>(),
);

export const loadSchoolAssignmentsFailure = createAction(
  '[Assessment] Load School Assignments Failure',
  props<{ schoolId: string; grade: string }>(),
);

export const createStudentAssignments = createAction(
  '[Assessment] Create Student Assignments',
  props<{ assignments: AssignmentResponse[]; key: string }>(),
);

export const createClassAssignments = createAction(
  '[Assessment] Create Class Assignments',
  props<{ assignments: AssignmentResponse[]; key: string }>(),
);

export const createSchoolAssignments = createAction(
  '[Assessment] Create School Assignments',
  props<{ assignments: AssignmentResponse[]; key: string }>(),
);

export const createStudentAssignmentsSuccess = createAction(
  '[Assessment] Create Student Assignments Success',
  props<{ assignments: AssignmentResponse[]; userId: string; key: string }>(),
);

export const createClassAssignmentsSuccess = createAction(
  '[Assessment] Create Class Assignments Success',
  props<{ assignments: AssignmentResponse[]; classId: string; key: string }>(),
);

export const createSchoolAssignmentsSuccess = createAction(
  '[Assessment] Create School Assignments Success',
  props<{ assignments: AssignmentResponse[]; schoolId: string; grade: string; key: string }>(),
);

export const createAssignmentsFailure = createAction(
  '[Assessment] Create Assignments Failure',
  props<{ key: string }>(),
);

export const archiveStudentBenchmarks = createAction(
  '[Assessment] Archive Student Assignments',
  props<{ assignments: AssignmentResponse[]; key: string }>(),
);

export const archiveStudentBenchmarksSuccess = createAction(
  '[Assessment] Archive Student Assignments Success',
  props<{ key: string }>(),
);

export const archiveStudentBenchmarksFailure = createAction(
  '[Assessment] Archive Student Assignments Failure',
  props<{ key: string }>(),
);

export const archiveSchoolBenchmarks = createAction(
  '[Assessment] Archive School Assignments',
  props<{ assignments: AssignmentResponse[]; key: string }>(),
);

export const archiveSchoolBenchmarksSuccess = createAction(
  '[Assessment] Archive School Assignments Success',
  props<{ key: string }>(),
);

export const archiveSchoolBenchmarksFailure = createAction(
  '[Assessment] Archive School Assignments Failure',
  props<{ key: string }>(),
);

export const archiveClassBenchmarks = createAction(
  '[Assessment] Archive Class Assignments',
  props<{ assignments: AssignmentResponse[]; key: string }>(),
);

export const archiveClassBenchmarksSuccess = createAction(
  '[Assessment] Archive Class Assignments Success',
  props<{ key: string }>(),
);

export const archiveClassBenchmarksFailure = createAction(
  '[Assessment] Archive Class Assignments Failure',
  props<{ key: string }>(),
);
